import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormHelperText, FormLabel } from "@mui/joy";
import { useEffect } from 'react';
import { useDefaultSubcategoryId } from '../hooks/useDefaultSubcategoryId';
import { SubcategorySelect } from './SubcategorySelect';

export function CategoryPicker({ name, label, optional, sx }) {
  const form = useFormContext();
  const errors = form.formState.errors;
  const defaultSubcategoryId = useDefaultSubcategoryId();
  const currentValue = form.watch(name);

  useEffect(() => {
    if (currentValue == null && defaultSubcategoryId != null) {
      form.setValue(name, defaultSubcategoryId, { shouldValidate: false });
    }
  }, [currentValue, defaultSubcategoryId, name, form]);

  return (
    <FormControl error={!!errors[name]} sx={sx}>
      {label && <FormLabel>{label} {optional && <span style={{ color: 'var(--joy-palette-neutral-400)' }}>(optional)</span>}</FormLabel>}
      <Controller
        name={name}
        control={form.control}
        render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
          <SubcategorySelect
            value={value}
            onChange={(subcategoryId) => onChange(subcategoryId ? Number(subcategoryId) : null)}
            onBlur={onBlur}
            optional={optional}
            error={error == null ? 'false' : 'true'}
          />
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
}
